import React from 'react';
import { useEffect, useState } from 'react';
import './index.css';
import ScrollIndicator from './components/ScrollIndicator';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
// import ScrollReviews from './components/ScrollReviews';
// TEMPORALMENTE OCULTO (restaurar junto con la sección de Precios): import ExpandableCards from './components/ExpandableCards';
import PointerHighlight from './components/PointerHighlight';
import LocationSection from './components/LocationSection';
import Logo from './components/Logo';
import FloatingBookingCTA from './components/FloatingBookingCTA';
import ReactGA from 'react-ga4';


const WHATSAPP_URL = `https://wa.me/59896761805?text=${encodeURIComponent('Hola, vengo de la página web y tengo una consulta.')}`;

function BookingCTA({ className = "", children = "Reservar ahora" }) {
  return (
    <a
      href="/book"
      className={`btn-pill ${className}`.trim()}
    >
      {children} <span className="arrow" aria-hidden="true">→</span>
    </a>
  );
}

const photoHover = {
  scale: [null, 1.1, 1.2],
  transition: {
    duration: 0.5,
    times: [0, 0.6, 1],
    ease: ["easeInOut", "easeOut"],
  },
};

const services = [
  {
    title: "Nuestra cera sistema español",
    text: "Uso de productos naturales y revolucionarios, proporcionando una depilación más, suave y eficaz.",
    images: [
      { src: "/images/cera.png", alt: "Depilación" },
      { src: "/images/cera2.png", alt: "Depilación" },
    ],
  },
  {
    title: "Laciado no termo activo y tratamientos para el cabello",
    text: "Alisa, hidrata y reduce el frizz de forma gradual. También botox capilar, baño de crema y brushing.",
    images: [
      { src: "/images/laciado.png", alt: "laciado" },
      { src: "/images/antesydespues.png", alt: "laciado" },
    ],
  },
  {
    title: "¡Potencia tu mirada!",
    text: "Perfilado de cejas + lifting de pestañas",
    images: [
      { src: "/images/cejas.png", alt: "Pestañas" },
      { src: "/images/pestañas.png", alt: "Pestañas" },
    ],
  },
  {
    title: "Head spa japonés",
    text: "Hidromasaje capilar con técnicas japonesas de liberación y masajes craneales, cervicales, de hombros y rostro.",
    images: [
      { src: "/images/headspa.png", alt: "Head spa japonés" },
    ],
  },
  {
    title: "Dile adiós al vello no deseado para siempre",
    text: "El láser Soprano Titanium es uno de los equipos más avanzados en depilación láser definitiva. Combina potencia, velocidad y comodidad, ideal para todo tipo de pieles durante todo el año",
    images: [
      { src: "/images/def.png", alt: "Depilación" },
      { src: "/images/dep.png", alt: "Depilación" },
    ],
  },
  {
    title: "Alivia el estrés y las tensiones emocionales con un masaje",
    text: "Un masaje te ayudará a recuperar la energía y venir la diferencia.",
    note: "¡Tu bienestar es lo primero!",
    images: [
      { src: "/images/masajes.png", alt: "Masajes" },
      { src: "/images/pies.png", alt: "Masajes" },
    ],
  },
];

// Carrusel del hero: alterna la foto del salón con un banner promocional.
// - Cambiar el banner: subir la imagen a public/images/ y poner su ruta acá.
// - Apagarlo: dejar la ruta en null (con las dos en null solo queda la foto del salón).
// Cada tamaño de pantalla usa su propia imagen; si la suya está en null, ahí no hay carrusel.
const HERO_BANNER = {
  mobile: "/images/banner-mobile-6x13.png", // vertical (aprox. 6:13)
  desktop: "/images/banner-dt.jpeg", // horizontal (aprox. 3:1)
  alt: "Descubrí GLAM: laciado no termoactivo, depilación, lifting de pestañas, head spa y mucho más. Elegí tu servicio y reservá online.",
};
const HERO_SLIDE_MS = 5000;
// En celular el navbar está oculto arriba de todo y aparece apenas se scrollea.
const NAV_SHOW_AFTER_PX = 8;
const MOBILE_QUERY = "(max-width: 767px)";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}

function App() {

  useEffect(() => {
    ReactGA.initialize("G-6YEPQ85GS2");
    ReactGA.send("pageview");
  }, []);

  const isMobile = useIsMobile();
  const heroBannerSrc = isMobile ? HERO_BANNER.mobile : HERO_BANNER.desktop;
  const heroCarruselOn = Boolean(heroBannerSrc);
  // 0 = banner, 1 = foto del salón
  const [heroSlide, setHeroSlide] = useState(0);
  const [heroPaused, setHeroPaused] = useState(false);
  useEffect(() => {
    if (!heroCarruselOn || heroPaused) return;
    const id = setInterval(() => setHeroSlide((s) => (s + 1) % 2), HERO_SLIDE_MS);
    return () => clearInterval(id);
  }, [heroCarruselOn, heroPaused]);
  const showBanner = heroCarruselOn && heroSlide === 0;
  // Con carrusel, en escritorio el hero toma la altura del banner para mostrarlo sin recortes
  // y la slide del salón se compacta para entrar en ese alto. En celular el hero ocupa toda
  // la pantalla (.hero-mobile-full) y el banner 6:13 se recorta centrado para llenarla.
  const heroCompact = heroCarruselOn && !isMobile;

  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(() => window.scrollY > NAV_SHOW_AFTER_PX);
  useMotionValueEvent(scrollY, "change", (latest) => {
    setScrolled(latest > NAV_SHOW_AFTER_PX);
  });
  const navOverHero = isMobile && !scrolled;

  return (

    <div className="bg-crema min-h-screen font-ui font-light text-espresso">

      <ScrollIndicator />

      {/* Top Nav Bar — en celular es fijo: arriba de todo solo se ve el logo sobre el hero de
          pantalla completa y el fondo aparece al scrollear; en escritorio es sticky y opaco. */}
      <header
        className={`top-0 z-30 border-b transition-colors duration-300 ease-out max-md:fixed max-md:inset-x-0 md:sticky ${navOverHero ? "border-transparent bg-transparent" : "border-vino/10 bg-rosa-polvo"}`}
      >
        {/* Sombra suave para que el logo blanco se lea sobre la foto */}
        <div
          aria-hidden="true"
          className={`pointer-events-none absolute inset-x-0 top-0 h-[150%] bg-gradient-to-b from-espresso/50 to-transparent transition-opacity duration-300 md:hidden ${navOverHero ? "opacity-100" : "opacity-0"}`}
        />
        {/* Logo centrado: columnas laterales iguales (nav a la izquierda, CTA a la derecha) */}
        <div className="container-glam relative grid grid-cols-[1fr_auto_1fr] items-center gap-6 py-3">
          <nav className="hidden justify-self-start lg:block">
            <ul className="flex items-center gap-6 font-ui text-[12px] font-bold uppercase tracking-[0.2em] xl:gap-9 xl:text-[14px] xl:tracking-[0.28em]">
              <li><a href="#servicios" className="text-white transition-colors hover:text-vino">Servicios</a></li>
              {/* TEMPORALMENTE OCULTO: <li><a href="#precios" className="text-espresso transition-colors hover:text-vino">Precios</a></li> */}
              <li><a href="#ubicacion" className="text-white transition-colors hover:text-vino">Ubicación</a></li>
              <li><a href="/book" className="text-white transition-colors hover:text-vino">Agenda</a></li>
            </ul>
          </nav>
          <a href="/" aria-label="GLAM beauty studio — inicio" className="col-start-2 shrink-0 justify-self-center">
            {/* En celular va sin badge: el fondo rosa-polvo lo pone el header al scrollear */}
            <Logo bare={isMobile} />
          </a>
          {/* En celular el CTA lo cubre el botón flotante de reserva */}
          <BookingCTA className="btn-pill--sm btn-pill--white col-start-3 hidden justify-self-end md:inline-flex">
            Reservar ahora
          </BookingCTA>
        </div>
      </header>

      {/* Hero — carrusel automático (foto del salón <-> promo) */}
      <section
        id="inicio"
        className={`hero-mobile-full relative grid grid-cols-1 items-center overflow-hidden ${heroCarruselOn ? "" : "min-h-[clamp(520px,82vh,820px)]"}`}
        onPointerEnter={(e) => { if (e.pointerType === "mouse") setHeroPaused(true); }}
        onPointerLeave={() => setHeroPaused(false)}
      >
        {/* Slide 1: foto del salón */}
        <img
          src="/images/new-hero.jpeg"
          alt="Interior de GLAM beauty studio"
          className={`absolute inset-0 h-full w-full object-cover object-[center_60%] transition-opacity duration-1000 ${showBanner ? "opacity-0" : "opacity-100"}`}
        />
        <div
          className={`absolute inset-0 transition-opacity duration-1000 ${showBanner ? "opacity-0" : "opacity-100"}`}
          style={{ background: "linear-gradient(90deg, rgba(18,30,29,0.62) 0%, rgba(18,30,29,0.38) 45%, rgba(18,30,29,0.05) 80%)" }}
        />

        {/* Slide 2: banner promo, clickeable a la agenda */}
        {heroCarruselOn && (
          <a
            href="/book"
            className={`relative col-start-1 row-start-1 block self-stretch transition-opacity duration-1000 ${showBanner ? "opacity-100" : "opacity-0 pointer-events-none"}`}
          >
            <img
              src={heroBannerSrc}
              alt={HERO_BANNER.alt}
              className="block h-full w-full object-cover object-left"
            />
          </a>
        )}

        {/* Texto del hero: solo en la slide de la foto. En celular los CTA no se van con el
            texto: quedan iguales y en el mismo lugar también sobre el banner. */}
        <div className={`relative col-start-1 row-start-1 w-full ${showBanner ? "pointer-events-none" : ""}`}>
          <div className={`container-glam py-12 text-crema ${heroCompact ? "md:py-8" : "md:py-20"}`}>
            <div className={`transition-opacity duration-1000 ${showBanner ? "opacity-0" : "opacity-100"}`}>
              <p className="eyebrow flex items-center gap-[18px]">
                Agenda online <span className="block h-px w-16 bg-rosa-polvo" aria-hidden="true" />
              </p>
              <h1 className={`mt-7 font-display font-thin uppercase leading-[1.02] tracking-[0.005em] [text-wrap:balance] ${heroCompact ? "max-w-[20ch] text-[clamp(34px,4.4vw,64px)]" : "max-w-[16ch] text-[clamp(40px,6.4vw,92px)]"}`}>
                Centro de belleza en Punta del Este
              </h1>
              <p className={`mt-7 font-accent text-[clamp(17px,1.6vw,21px)] italic leading-normal [text-wrap:pretty] ${heroCompact ? "" : "max-w-[30ch]"}`}>
                Reservá online en segundos y elegí el servicio que mejor se adapte a vos.
              </p>
            </div>
            <div className={`flex flex-wrap gap-3.5 transition-opacity duration-1000 ${heroCompact ? "mt-8" : "mt-10"} ${showBanner ? (isMobile ? "pointer-events-auto" : "opacity-0") : ""}`}>
              <BookingCTA className="btn-pill--light">
                Reservar turno
              </BookingCTA>
              <a href="#servicios" className="btn-pill btn-pill--outline">
                Ver servicios
              </a>
            </div>
          </div>
        </div>

        {/* Indicadores del carrusel */}
        {heroCarruselOn && (
          <div className="absolute bottom-3 left-1/2 z-10 flex -translate-x-1/2 gap-2">
            {[0, 1].map((i) => (
              <button
                key={i}
                type="button"
                onClick={() => setHeroSlide(i)}
                aria-label={`Ver imagen ${i + 1} de 2`}
                className={`h-2 rounded-full shadow transition-all ${heroSlide === i ? "w-6 bg-white" : "w-2 bg-white/60 hover:bg-white/80"}`}
              />
            ))}
          </div>
        )}
      </section>

      <main>
        {/* ¿Por qué elegir nuestro servicio? */}
        <section className="container-glam section-pad grid items-start gap-[clamp(48px,6vw,96px)] md:grid-cols-2">
          <div>
            <div className="h-px w-16 bg-rosa-polvo" aria-hidden="true" />
            <h2 className="display-title mt-7">
              Una experiencia pensada para vos.
            </h2>
            <p className="mt-[22px] font-ui text-[13px] font-light uppercase tracking-[0.4em] text-vino/80">
              ¿Por qué elegir nuestro servicio?
            </p>
          </div>
          <div className="border-t border-dorado pt-10 text-[17px] leading-[1.7] md:mt-[6px] md:border-t-0 md:pt-0">
            <p className="max-w-[44ch] [text-wrap:pretty]">
              <PointerHighlight
                rectangleClassName="bg-blush border-rosa-polvo"
                pointerClassName="text-vino"
              >
                <span className="font-medium">Compromiso con la Calidad:</span>
              </PointerHighlight>
              {" "}Sabemos que nuestras clientas habituales ya conocen y valoran todos estos aspectos, pero queremos que las nuevas también sepan que estamos comprometidos con ofrecerle la{" "}
              <PointerHighlight
                rectangleClassName="bg-blush border-rosa-polvo"
                pointerClassName="text-vino"
              >
                <span className="font-medium italic">mejor experiencia</span>
              </PointerHighlight>
              {" "}en cada visita.
            </p>
            <div className="mt-10">
              <a href="#servicios" className="btn-pill btn-pill--sm btn-pill--vino">
                Conocé nuestros servicios <span className="arrow" aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </section>

        {/* Nuestros servicios */}
        <section id="servicios" className="scroll-mt-20 bg-white">
          <div className="container-glam section-pad">
            <div className="flex flex-wrap items-end justify-between gap-6">
              <div>
                <p className="eyebrow text-vino">Servicios</p>
                <h2 className="display-title mt-5">Nuestros servicios</h2>
              </div>
              <p className="max-w-[34ch] font-accent text-lg italic leading-normal">
                Cada servicio, con el tiempo y la atención que merece.
              </p>
            </div>

            <div className="mt-16 grid gap-px border border-dorado bg-blush sm:grid-cols-2 lg:grid-cols-3">
              {services.map((service, index) => (
                <article key={service.title} className="flex flex-col gap-6 bg-crema px-8 pb-10 pt-9">
                  <div className="flex items-baseline justify-between">
                    <div className="flex">
                      {service.images.map((image, imageIndex) => (
                        <motion.div
                          key={image.src}
                          className={`h-20 w-20 overflow-hidden rounded-full ring-1 ring-rosa-polvo ring-offset-2 ring-offset-crema ${imageIndex === 0 ? "mr-3" : ""}`}
                          whileHover={photoHover}
                        >
                          <img src={image.src} alt={image.alt} className="h-full w-full object-cover" />
                        </motion.div>
                      ))}
                    </div>
                    <span className="font-display text-sm font-extralight text-vino">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-ui text-xs font-medium uppercase leading-relaxed tracking-[0.32em]">{service.title}</h3>
                    <p className="mt-3 text-base leading-[1.6] [text-wrap:pretty]">{service.text}</p>
                    {service.note && (
                      <p className="mt-3 font-accent text-base italic text-vino">{service.note}</p>
                    )}
                  </div>
                  <a
                    href="/book"
                    className="group flex items-center justify-between border-t border-dorado pt-4 font-ui text-[10px] font-medium uppercase tracking-[0.3em] text-vino transition-colors hover:text-espresso"
                  >
                    Reservar <span className="arrow text-rosa-polvo transition-transform group-hover:translate-x-1" aria-hidden="true">→</span>
                  </a>
                </article>
              ))}
              <a
                href="/book"
                className="group flex flex-col justify-between gap-10 bg-rosa-polvo px-8 pb-10 pt-9 text-crema transition-colors hover:bg-vino hover:text-crema sm:col-span-2 lg:col-span-3"
              >
                <span className="eyebrow">Agenda online</span>
                <span>
                  <span className="block font-display text-[clamp(28px,3vw,40px)] font-thin uppercase leading-[1.05]">Reservá tu turno</span>
                  <span className="mt-4 block font-accent text-base italic text-white">Elegí el día y horario que más se adapte a vos.</span>
                </span>
                <span className="flex items-center justify-between border-t border-crema/20 pt-4 font-ui text-[10px] font-medium uppercase tracking-[0.3em]">
                  Ir a la agenda <span className="arrow transition-transform group-hover:translate-x-1" aria-hidden="true">→</span>
                </span>
              </a>
            </div>
          </div>
        </section>

        {/* Precios — TEMPORALMENTE OCULTA (restaurar descomentando) */}
        {/* <section id="precios" className="mb-16 pt-16 -mt-16">
          <h2 className="font-ui text-sm md:text-base uppercase tracking-[0.32em] font-medium mb-8 text-center italic">PRECIOS</h2>
          <ExpandableCards />
          <div className="mt-10 flex justify-center">
            <BookingCTA className="min-w-[240px] md:min-w-[280px]">
              Reservar ahora
            </BookingCTA>
          </div>
        </section> */}

        {/* Reseñas */}
        {/* <section className="mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-light tracking-[-0.03em] mb-10 text-center ">
            Recomendaciones
           </h2>
             <br />
          <ScrollReviews reviews={[
            {
              name: "Nombre Usuario",
              source: "Google Maps",
              stars: 5,
              comment: "La mejor estética a la que ido... Excelente atención",
              image: "/profile1.jpg",
            },
            {
              name: "Ana Silva",
              source: "Google Maps",
              stars: 5,
              comment: "Excelente atención, mejor lugar para depilarse. ¡Recomiendo!",
              image: "/profile2.jpg",
            },
            {
              name: "Gloria Estrada",
              source: "Google Maps",
              stars: 5,
              comment: "Excelente, muy limpio, la dueña es una gran profesional",
              image: "/profile3.jpg",
            },
            {
              name: "Laura Mendoza",
              source: "Google Maps",
              stars: 5,
              comment: "El servicio es increíble, siempre salgo muy satisfecha con los resultados.",
              image: "/profile1.jpg",
            },
            {
              name: "María Fernandez",
              source: "Google Maps",
              stars: 5,
              comment: "No cambiaría este lugar por nada, la atención es personalizada y los precios son justos.",
              image: "/profile2.jpg",
            },
            {
              name: "Carolina Lopez",
              source: "Instagram",
              stars: 5,
              comment: "Me encanta cómo queda mi piel después de cada sesión. ¡Súper recomendada!",
              image: "/profile3.jpg",
            },
          ]} />
        </section> */}

        {/* Ubicación */}
        <section id="ubicacion" className="scroll-mt-20 bg-white">
          <LocationSection />
        </section>

        {/* Reserva */}
        <section className="bg-white text-espresso">
          <div className="container-glam flex flex-wrap items-center justify-between gap-10 py-[clamp(80px,10vw,128px)]">
            <div>
              <h2 className="max-w-[14ch] font-display text-[clamp(36px,5vw,72px)] font-thin uppercase leading-[1.04]">
                Tu momento te espera.
              </h2>
              <p className="mt-[22px] font-accent text-[19px] italic text-vino">
                Reservá online o escribinos por WhatsApp.
              </p>
            </div>
            <div className="flex flex-wrap gap-3.5">
              <BookingCTA className="btn-pill--vino">
                Reservar ahora
              </BookingCTA>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-pill btn-pill--outline-vino">
                WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Dock flotante: reserva (aparece al bajar) + WhatsApp */}
      <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
        <FloatingBookingCTA />
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-vino text-white shadow-lg ring-1 ring-white/25 transition hover:scale-110 hover:bg-espresso"
          aria-label="Contactar por WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-7 w-7">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        </a>
      </div>

      {/* Footer */}
      <footer id="contacto" className="border-t border-vino/15 bg-rosa-polvo text-white">
        <div className="container-glam grid gap-12 pb-10 pt-20 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo className="h-20 md:h-24" />
          </div>
          <div className="flex flex-col gap-3">
            <p className="eyebrow text-white">Dónde</p>
            <p className="font-accent text-[15px] leading-relaxed">
              Avenida España y Cuba<br />Parada 25, La Mansa<br />Punta del Este, Uruguay
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="eyebrow text-white">Contacto</p>
            <a href="tel:+59896761805" className="font-accent text-[15px] text-white transition-colors hover:text-vino">+598 96 761 805</a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="font-accent text-[15px] text-white transition-colors hover:text-vino">WhatsApp</a>
          </div>
          <div className="flex flex-col gap-3">
            <p className="eyebrow text-white">Seguinos</p>
            <a href="https://www.instagram.com/glam_depi/" target="_blank" rel="noopener noreferrer" className="font-accent text-[15px] text-white transition-colors hover:text-vino">Instagram</a>
          </div>
        </div>
        <div className="container-glam flex flex-wrap justify-between gap-3 border-t border-vino/15 pb-10 pt-6 text-xs tracking-[0.08em] text-white">
          <span>© {new Date().getFullYear()} GLAM beauty studio</span>
          <span>
            Sitio creado por <a href="https://netfusion.services/" className="text-white hover:underline">NetFusion</a>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;
